// extracted by mini-css-extract-plugin
export default {"root":"Label_root__PsrIA","header":"Label_header__Rn83+","label":"Label_label__Lzlrm","error":"Label_error__Gr5hi"};